import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import CoupleAccent from "@/components/CoupleAccent";

export const Hero = ({ onBegin }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex flex-col items-center justify-center text-center px-6 sm:px-12"
    >
      <CoupleAccent
        src="/couple/hug.png"
        alt="us hugging"
        className="hidden md:block absolute top-10 right-6 lg:right-20 w-28 lg:w-36 rotate-[6deg] pointer-events-none"
        float={{ y: [0, -10, 0], rotate: [6, 2, 6] }}
        duration={6}
        delay={1.6}
      />
      <CoupleAccent
        src="/couple/eva_pouty.png"
        alt="eva a little upset"
        className="hidden lg:block absolute bottom-16 left-8 w-24 -rotate-[6deg] pointer-events-none"
        float={{ y: [0, -6, 0], rotate: [-6, -9, -6] }}
        duration={7.2}
        delay={1.9}
      />
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        className="font-hand text-3xl sm:text-4xl text-rose-400 mb-6"
      >
        for the only one — Eva
      </motion.p>

      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.4, delay: 0.2, ease: "easeOut" }}
        className="font-serif-love text-5xl sm:text-6xl md:text-7xl leading-[1.05] text-[#3A2C2C] max-w-3xl"
      >
        i'm{" "}
        <span className="italic text-[#C28080] underline-love">sorry</span>.
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.9, ease: "easeOut" }}
        className="font-body-love text-base sm:text-lg text-[#7D6B6B] mt-8 max-w-xl leading-relaxed"
      >
        A letter i should have written the first time i hurt you. Take your
        time. Read every word. I mean each one of them.
      </motion.p>

      <motion.button
        data-testid="hero-begin-button"
        onClick={onBegin}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 1.4 }}
        whileHover={{ y: -3 }}
        whileTap={{ scale: 0.97 }}
        className="mt-12 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#D4A3A3] text-white font-medium shadow-lg shadow-rose-200/60 hover:bg-[#C28080] transition-colors"
      >
        <Heart className="w-4 h-4" fill="currentColor" strokeWidth={0} />
        open my letter
      </motion.button>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.2, duration: 1.4 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#C28080] text-xs tracking-[0.35em] uppercase"
      >
        scroll gently
      </motion.div>
    </section>
  );
};

export default Hero;
